const IA_API_URL = 'https://iad.anw.cloud/api/v1/ia'

interface GenerateStreamPayload {
  prompt: string
  engine: string
}

interface TranslatePayload {
  text: string
  target_language: string
  engine: string
}

export const useIAService = () => {
  const generateStream = async (
    payload: GenerateStreamPayload,
    signal?: AbortSignal,
  ): Promise<ReadableStream<Uint8Array>> => {
    const response = await fetch(`${IA_API_URL}/generate/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      signal,
    })

    if (!response.ok || !response.body) {
      throw new Error(`Error ${response.status}`)
    }

    return response.body
  }

  const translate = async (payload: TranslatePayload): Promise<string> => {
    const response = await fetch(`${IA_API_URL}/translate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })

    if (!response.ok) {
      throw new Error(`Error ${response.status}`)
    }

    const data = await response.json()
    return typeof data === 'string' ? data : (data.translation ?? '')
  }

  return {
    generateStream,
    translate,
  }
}
